<div class="body" [formGroup]="formGroup">

    <div formArrayName="contactInformation" class="content">

        <table mat-table [dataSource]="itemControl.controls|sortedFormArray:active:direction:itemControl.value.length" class="table" matSort (matSortChange)="sortData($event)">

            <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value">

                    <mat-icon class="icon">{{element.value.controls['infotype'].value|contactInformationTypeIcon}}</mat-icon>

                </td>
            </ng-container>

            <ng-container matColumnDef="infotype">
                <th mat-header-cell mat-sort-header="infotype" *matHeaderCellDef>Art</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value">

                    <app-select-contact-information-type formControlName="infotype" appearance="raw" style="width: 10rem; display: block;" [disabled]="disabled"></app-select-contact-information-type>

                </td>
            </ng-container>

            <ng-container matColumnDef="infovalue">
                <th mat-header-cell mat-sort-header="itemcount" *matHeaderCellDef>Wert</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="infovalue" class="input" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="controls">

                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="control-cell">

                    <button mat-icon-button color="warn" [disabled]="disabled" (click)="removeItem(element.key)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>

                </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>

        </table>

    </div>

</div>
